import { HousingCard } from './HousingCard';

export type { TypeHousingCardProps } from './types';
export default HousingCard;
